import type { TrackedEvent } from './eventNames';

export const track = (event: TrackedEvent) => {
  const { event: eventName, ...meta } = event;

  janeMixpanel.track(eventName, meta);
};
